export const validateFiles = (selectedFiles, validationRules) => {
    const results = {
        isValid: true,
        errors: [],
        fileValidations: [],
        rejectedFiles: [],
    }

    if (!selectedFiles || selectedFiles.length === 0) {
        return results
    }

    const filesByContentType = {}

    selectedFiles.forEach((file) => {
        const contentType = determineContentType(file, validationRules)

        if (!filesByContentType[contentType]) {
            filesByContentType[contentType] = []
        }
        filesByContentType[contentType].push(file)
    })

    Object.keys(filesByContentType).forEach((contentType) => {
        const rule = validationRules.find((item) => item.content_type === contentType)
        const contentTypeFiles = filesByContentType[contentType]

        const uniqueExtensions = [
            ...new Set(contentTypeFiles.map((file) => getFileExtension(file.name))),
        ]

        if (!rule) {
            const fileNames = contentTypeFiles.map((file) => file.name).join(', ')

            results.errors.push(
                `Формат ${uniqueExtensions.join(', ')} не поддерживается выбранной моделью, ${fileNames} не был загружен`,
            )
            results.rejectedFiles.push(...contentTypeFiles.map((file) => ({ file })))
            results.isValid = false
            return
        }

        if (!rule.is_supported) {
            const fileNames = contentTypeFiles.map((file) => file.name).join(', ')
            results.errors.push(
                `Тип файлов с расширениями ${uniqueExtensions.join(', ')} не поддерживается. Файлы не были добавлены: ${fileNames}`,
            )
            results.rejectedFiles.push(...contentTypeFiles.map((file) => ({ file })))
            results.isValid = false
            return
        }

        if (contentTypeFiles.length > rule.max_file_count) {
            const allowedFiles = contentTypeFiles.slice(0, rule.max_file_count)
            const rejectedFiles = contentTypeFiles.slice(rule.max_file_count)
            const rejectedFileNames = rejectedFiles.map((file) => file.name).join(', ')

            results.errors.push(
                `Превышено максимальное общее количество файлов с расширениями ${uniqueExtensions.join(', ')}: ${contentTypeFiles.length} из ${rule.max_file_count}. Файлы не были добавлены: ${rejectedFileNames}`,
            )
            results.rejectedFiles.push(
                ...rejectedFiles.map((file) => ({
                    file,
                })),
            )
            results.isValid = false

            contentTypeFiles.splice(0, contentTypeFiles.length, ...allowedFiles)
        }

        const totalSize = contentTypeFiles.reduce((sum, file) => sum + file.size, 0)
        if (totalSize > rule.file_size) {
            const sortedFiles = [...contentTypeFiles].sort((a, b) => a.size - b.size)
            let currentSize = 0
            const allowedFiles = []
            const rejectedFiles = []

            sortedFiles.forEach((file) => {
                if (currentSize + file.size <= rule.file_size) {
                    currentSize += file.size
                    allowedFiles.push(file)
                } else {
                    rejectedFiles.push(file)
                }
            })

            const rejectedFileNames = rejectedFiles.map((file) => file.name).join(', ')

            results.errors.push(
                `Превышен максимальный общий размер для файлов с расширениями ${uniqueExtensions.join(', ')}: ${(totalSize / 1024 / 1024).toFixed(2)} МБ из ${(rule.file_size / 1024 / 1024).toFixed(2)} МБ. Файлы не были добавлены: ${rejectedFileNames}`,
            )
            results.rejectedFiles.push(...rejectedFiles.map((file) => ({ file })))
            results.isValid = false

            contentTypeFiles.splice(0, contentTypeFiles.length, ...allowedFiles)
        }

        contentTypeFiles.forEach((file) => {
            const fileExtension = getFileExtension(file.name)
            const isValidExtension = rule.available_extensions.includes(fileExtension.toLowerCase())

            results.fileValidations.push(file)

            if (!isValidExtension) {
                results.errors.push(
                    `Файл ${file.name} имеет недопустимое расширение: ${fileExtension}. Файл не был добавлен`,
                )
                results.rejectedFiles.push({ file })
                results.isValid = false
            }
        })
    })

    return results
}

const determineContentType = (file, validationRules) => {
    const fileExtension = getFileExtension(file.name).toLowerCase()

    const matchingRule = validationRules.find(
        (rule) =>
            rule.is_supported &&
            rule.available_extensions.map((ext) => ext.toLowerCase()).includes(fileExtension),
    )

    return matchingRule ? matchingRule.content_type : 'UNKNOWN'
}

const getFileExtension = (filename) => {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2)
}
